// Typed oRPC client + TanStack Query utilities.
// Dev: same-origin via the Vite proxy (/rpc → API). Prod: VITE_API_URL points at
// the API origin (same-site subdomain). credentials are included so the
// better-auth session cookie travels with every call.

import { createORPCClient } from '@orpc/client';
import { RPCLink } from '@orpc/client/fetch';
import type { ContractRouterClient } from '@orpc/contract';
import { createTanstackQueryUtils } from '@orpc/tanstack-query';
import type { Contract } from '@delvero/contracts';
import { API_BASE } from './apiBase';

// RPCLink builds requests with `new URL(...)`, which requires an ABSOLUTE base — a relative
// "/rpc" throws "Invalid URL". API_BASE defaults to the current origin (proxied to the API
// same-origin); VITE_API_URL points at a cross-origin API.
const link = new RPCLink({
  url: `${API_BASE}/rpc`,
  fetch: (request, init) => globalThis.fetch(request, { ...init, credentials: 'include' }),
});

export const client: ContractRouterClient<Contract> = createORPCClient(link);

/** TanStack Query helpers: `orpc.<ns>.<proc>.queryOptions({ input })` / `.mutationOptions()` / `.key()`. */
export const orpc = createTanstackQueryUtils(client);
